<template>
<body id="page-top" class="member-page-body">
        <!-- Navigation-->
        <nav class="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
            <div class="container">
                <img class="navbar-brand" href="#page-top" src="../assets/philcare-logo.png"/>
                    <i class="fas fa-bars"></i>
            </div>
        </nav>
        <section class="page-section portfolio member-page-section" id="portfolio">
            <div class="container">
                
                <div class="row align-items-start">
                    <div  v-if="step === 0" class="loa-lab-flex">
                    <div class="col loa-lab-steps steps-active">
                      1
                    </div>
                    <div class="col loa-lab-steps">
                      2
                    </div>
                    <div class="col loa-lab-steps">
                      3
                    </div>
                    <div class="col loa-lab-steps">
                      4
                    </div>
                    <div class="col loa-lab-steps">
                      5
                    </div>
                  </div>

                    <div  v-if="step === 1"  class="loa-lab-flex">
                    <div class="col loa-lab-steps steps-done">
                      1
                    </div>
                    <div class="col loa-lab-steps steps-active">
                      2
                    </div>
                    <div class="col loa-lab-steps">
                      3
                    </div>
                    <div class="col loa-lab-steps">
                      4
                    </div>
                    <div class="col loa-lab-steps">
                      5
                    </div>
                    </div>

                    <div v-if="step === 2" class="loa-lab-flex">
                    <div class="col loa-lab-steps steps-done">
                      1
                    </div>
                    <div class="col loa-lab-steps steps-done">
                      2
                    </div>
                    <div class="col loa-lab-steps steps-active">
                      3
                    </div>
                    <div class="col loa-lab-steps">
                      4
                    </div>
                     <div class="col loa-lab-steps">
                      5
                    </div>
                    </div>

                    <div v-if="step === 3" class="loa-lab-flex">
                    <div class="col loa-lab-steps steps-done">
                      1
                    </div>
                    <div class="col loa-lab-steps steps-done">
                      2
                    </div>
                    <div class="col loa-lab-steps steps-done">
                      3
                    </div>
                    <div class="col loa-lab-steps steps-active">
                      4
                    </div>
                    <div class="col loa-lab-steps">
                      5
                    </div>
                    </div>

                    <div v-if="step === 4" class="loa-lab-flex">
                    <div class="col loa-lab-steps steps-done">
                      1
                    </div>
                    <div class="col loa-lab-steps steps-done">
                      2
                    </div>
                    <div class="col loa-lab-steps steps-done">
                      3
                    </div>
                    <div class="col loa-lab-steps steps-done">
                      4
                    </div>
                    <div class="col loa-lab-steps steps-active">
                      5
                    </div>
                    </div>

               
            <section v-if="step === 0" class="page-section portfolio loa-lab-fap" id="portfolio">
            <div class="container">
                <div class="row justify-content-center loa-form">
                        <FindAProvider v-on:providercode="updateParentProvider" v-on:providername="updateParentProviderName" /> 
                </div>
            </div>
            </section>
                <div v-if="step > 0" class="row loa-form">
                    <form autocomplete="off" @submit.prevent="handleSubmit"  >
                    <div class="login-form">
                      <div v-if="step === 1">
                        <div v-if="!isNonAffiliated" class="mt-3">
                            <p class="h4">WHO IS YOUR DOCTOR?</p>
                          
                          <div class="mb-3 row">
                                <label for="exampleFormControlTextarea1" class="col-sm-2 col-form-label">Doctor Name*</label>
                                <div class="col-sm-10">
                                  <input autocomplete="off" style="width:90%;" v-b-modal.modal-center v-model="DoctorName" class="form-control" id="exampleFormControlTextarea1" type="search" aria-label="Search" required>
                                </div>
                              
                          </div>
                          
                       </div>
                       <div v-if="isNonAffiliated" class="mt-3 non-affiliated-form">
                          <p class="h4">PLEASE ENTER THE DOCTOR'S COMPLETE NAME</p>

                          <!-- Doctor Type Radio (moved to first field) -->
                          <div class="mb-3">
                            <div class="form-check form-check-inline form-check-first ">
                              <input 
                                type="radio" 
                                id="doctor-company" 
                                value="company" 
                                v-model="doctorType" 
                                class="form-check-input"
                                required
                              />
                              <label for="doctor-company" class="form-check-label">Company Doctor</label>
                            </div>
                            <div class="form-check form-check-inline">
                              <input 
                                type="radio" 
                                id="doctor-non-affiliated" 
                                value="non-affiliated" 
                                v-model="doctorType" 
                                class="form-check-input"
                                required
                              />
                              <label for="doctor-non-affiliated" class="form-check-label">Non-Affiliated</label>
                            </div>
                          </div>

                          <!-- Doctor Name -->
                          <div class="mb-3">
                            <label>Doctor's Name (Last Name, First Name, Middle Initial)</label>
                            <input type="text" v-model="nonAffiliatedDoctorName" class="form-control" required />
                          </div>

                          <!-- Specialization -->
                          <div class="mb-3">
                            <label>Specialization</label>
                            <input type="text" v-model="nonAffiliatedSpecialization" class="form-control" required />
                          </div>
                        </div>

                        <div>
                        <!--<b-button style="float:right; margin-top:25px;" v-b-modal.modal-center type="button" class="btn btn-primary btn-lg">SEARCH</b-button>-->
                        

                        <b-modal id="modal-scrollable" ref="search-modal" scrollable title="List of Doctors:">
                            <div>
                            <a v-if="Doctors.length == 0" style="font-size:30px;">Please enter a Doctor Name.</a>
                            <a v-else-if="Doctors.length != 0" class="my-4 doctor-list" v-for="item in Doctors" :key="item.DoctorCode" @click="handleSelectItem(item)" > 
                            {{item.DoctorName}}<br>
                            {{item.Specialization}}<br>
                            {{item.TelNo}}
                            </a>
                            </div>
                        </b-modal>

                        <b-modal id="modal-center" ref="name-modal" content-class="customer-adv-modal" centered title="" @shown="focusFirstInput">
                        <div class="mb-3 row">
                            <label for="exampleFormControlTextarea1" class="col-sm-2 col-form-label">Last Name</label>
                            <div class="col-sm-10">
                              <input ref="firstInput" autocomplete="off" v-model="LastName" class="form-control" id="exampleFormControlTextarea1" type="search" aria-label="Search" @focus="show" data-layout="normal" required>
                            </div>
                            </div>
                        <div class="mb-3 row">
                            <label for="exampleFormControlTextarea1" class="col-sm-2 col-form-label">First Name</label>
                            <div class="col-sm-10">
                              <input autocomplete="off" v-model="FirstName" class="form-control" id="exampleFormControlTextarea1" type="search" aria-label="Search" @focus="show" data-layout="normal" required>
                            </div>
                           </div>            
                           <b-button @click="searchDoctor" v-b-modal.modal-scrollable type="button" class="search-btn">Search</b-button>
                      </b-modal>
                        </div>

                    </div>
                     <!--PAGE-2-->
                    <div v-if="step === 3">
                      <p class="h4">WHAT WAS YOUR DIAGNOSIS FROM THE DOCTOR?</p>
                        <div class="mb-3">
                            <label for="exampleFormControlTextarea1" class="form-label"></label>
                            <textarea v-model="Diagnosis" style="width: 90%;" class="form-control" id="exampleFormControlTextarea1" rows="3" @focus="show" data-layout="normal" required></textarea>
                          </div>
                    </div>
                    <!--PAGE-3-->

                    <div v-if="step === 2">
                      <p class="h4">HOW ARE YOU FEELING? WHAT IS YOUR CHIEF COMPLAINT?</p>
                        <div class="mb-3">
                            <label for="exampleFormControlTextarea1" class="form-label"></label>
                            <textarea v-model="ChiefComplaint" style="width: 90%;" class="form-control" id="exampleFormControlTextarea1" rows="3" @focus="show" data-layout="normal" required></textarea>
                          </div>
                    </div>

                    <div v-if="step === 4">
                    <div class="scan-message-form">
                            <div>
                                <p>To proceed, please prepare the doctor's request or prescription. Press "SCAN" to take clear picture of the documents or press "ATTACH FILE" to upload clear image of the doctor's request or prescription.</p>
                                <div class="form-group justify-content-center">
                                  <b-button v-b-modal.modal-center class="btn-action button is-rounded mr-4" :class="{ 'is-primary' : !isCameraOpen, 'is-danger' : isCameraOpen}" @click="toggleCamera">SCAN</b-button>
                                  <b-button class="btn-action button is-rounded" @click="toggleFileUpload">ATTACH FILE</b-button>
                                 </div>
                                <div>
                                
                                  
                                  <!--FILE UPLOAD-->
                                  <b-modal v-model="modalVisible" ref="upload-modal" id="upload-modal" centered title="Attachment" @hide="onModalCloseUpload" >
                                    <div class="form-group row justify-content-center align-items-center">
                                      <input type="file" class="mt-2 form-control" ref="fileInput" accept="image/jpeg, image/png, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/zip" @change="handleFileUpload(1, $event)">
                                      <input type="file" class="mt-2 form-control" ref="fileInput" accept="image/jpeg, image/png, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/zip" @change="handleFileUpload(2, $event)">
                                      <input type="file" class="mt-2 form-control" ref="fileInput" accept="image/jpeg, image/png, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/zip" @change="handleFileUpload(3, $event)">
                                      <input type="file" class="mt-2 form-control" ref="fileInput" accept="image/jpeg, image/png, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/zip" @change="handleFileUpload(4, $event)">
                                      <input type="file" class="mt-2 form-control" ref="fileInput" accept="image/jpeg, image/png, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/zip" @change="handleFileUpload(5, $event)">
                                    </div>
                                     <button class="btn btn-primary" @click="UploadImages" :disabled="uploadedImages.filter(img => img).length === 0">Submit</button>
                                      <!--<div v-for="(image, index) in uploadedImages" :key="index">
                                        <img :src="image.url" alt="Uploaded Image" style="max-width: 200px; margin: 10px;">
                                      </div>-->
                                    
                                  </b-modal>

                                  <b-modal ref="scan-modal" id="modal-center" centered title="" @hide="onModalClose">
                                    <div class="row">
                                      <div class="col-md-6">
                                    <div id="app" class="web-camera-container">
                              
                                    <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash' : isShotPhoto }">
                                    
                                    <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>
                                      
                                    <video v-show="!isPhotoTaken" ref="camera" :width="450" :height="337.5" autoplay></video>
                                    
                                    <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="450" :height="337.5"></canvas>
                              </div>
                              
              
                              
                             <!--<div v-if="isPhotoTaken && isCameraOpen" class="camera-download">
                                <a id="downloadPhoto" download="my-photo.jpg" class="button" role="button" @click="downloadImage">
                                  Download
                                </a>
                              </div>-->
                            </div>
                            </div>
                                    <div  class="col-md-6" ref="scan-div">
                                      <div v-if="steps === 1">
                                      <p class= "scan-message">Hold and face the prescription on the camera and make sure that the document is positioned within the frame.<br><br>Press "OK" button to take a picture.</p>
                                      <div v-if="isCameraOpen && !isLoading" class="camera-shoot">
                                <button v-b-modal.modal-lab type="button" class="button take-scan-btn" @click="takePhoto">
                                  <p class= "scan-ok-btn">OK</p>
                                </button>
                                </div>
                                </div>
                                <div v-if="steps === 2"> 
                                      <p style="text-align: center;" class= "scan-message">Do you want to take another photo?</p>
                                      <div style="text-align: center; margin-right: 50px;">
                                      <button style="font-size: 40px; color: white; margin-right: 30px; padding-right: 25px; padding-left: 25px;" type="button" class="button take-scan-btn" @click="previousSteps()">YES</button>
                                      <button style="font-size: 40px; color: white; margin-right: 30px; padding-right: 25px; padding-left: 25px;" type="button" class="button take-scan-btn" @click="nextStep()">NO</button>
                                      </div>         
                                    </div>
                                    </div>
                                    
                                  </div>
                                  </b-modal>
                                </div>
                            </div>
                          </div>
                    </div>
                    <!--PAGE-4-->
                    <div  v-if="step === 5">
                        <p>Our Customer Experience Advocate may need to call you for verification on the request for the 
                          laboratory test or will send an SMS to notify you of the created Letter of Authorization(LOA)<br><br>Please make sure to type in your correct and active mobile number.</p>     
                <div class="row justify-content-center d-flex align-items-center">
                    <div class="col-5" >
                        <strong class="phone-label">Type your mobile number</strong>
                      </div>
                    <div class="col-7">
                        <div class="input-phone-number col-md-12">
                           <input v-model="vuePhone.phone" @focus="show" data-layout="numeric" type="tel" style="width: 70%; font-size: 28px; padding-left: 10px;" placeholder="(09)XX-XXX-XXXX" id="phone" name="phone" v-mask="'(09)##-###-####'" required>
                      </div>
                    </div>
                </div>
                <div class="row justify-content-center d-flex align-items-center">
                    <div class="col-5">
                        <strong class="phone-label">Re-type your mobile number</strong>
                      </div>
                    <div class="col-7">
                        <div class="input-phone-number col-md-12">
                            <input v-model="vuePhone.verify" @focus="show" data-layout="numeric" type="tel" style="width: 70%; font-size: 28px; padding-left: 10px;" id="phone" placeholder="(09)XX-XXX-XXXX" name="phone" v-mask="'(09)##-###-####'" required>
                      </div>
                    </div>
                      </div>
                    </div>
                    </div>


                       <div v-if="step === 0 || step === 1 || step === 2 || step === 3  || step === 4" class="col-md-12 member-custom-btn">
                  <router-link to="/member-page"><a style="float:left" type="button" class="btn btn-primary btn-lg">CANCEL</a></router-link>
                  <button type="button" @click='previousStep' class="btn btn-primary btn-lg" :disabled="step == 0">PREVIOUS</button>
                  <button class="btn btn-primary btn-lg" :disabled="step === 4">NEXT</button>
            </div>
             <div v-if="step === 5" class="col-md-12 member-custom-btn">
                  <a style="float:left" type="button" class="btn btn-primary btn-lg"><router-link to="/member-page">CANCEL</router-link></a>
                  <button @click='previousStep' class="btn btn-primary btn-lg" :disabled="step == 1">PREVIOUS</button>
                 <button type="submit" class="btn btn-primary btn-lg">SUBMIT</button>
                  </div>
                    </form>
                    <b-modal ref="my-modal" id="modal-number" :content-class="error === false ? 'customer-adv-modal custom-lab-modal' : 'customer-adv-modal'" centered title="" no-close-on-backdrop hide-close-button>
                       <p>{{message}}</p>
                         <button v-if="error === false && loading === false"  @click='logOut'>OK</button>     
                         <b-button v-if="error === true && loading === false"  @click="closeModalError">OK</b-button>       
                    </b-modal>
                </div>  
                </div>       
        </div>
        <b-modal ref="error-modal" title="Error" @hidden="clearErrorMessage" class="custom-modal">
        <p>{{ errorMessage }}</p>
       </b-modal>                       
        </section>
        <div class='spinner load' v-if='loading'><img src="../assets/phil-care-loading-logo.gif"/></div>
       
</body>
</template>


<script>
import FindAProvider from '../components/FindAProvider.vue'
import axios from 'axios';
export default {
  name: 'DoctorName',
  data() {
    return {
      certNo: '',
      TokenID: '',
      LastName: '',
      FirstName: '',
      Doctors: [],
      DoctorName:'',
      DoctorCode:'',
      step: 0,
      steps: 1,
      Attachement:[],
      files: [],
      uploadedImages: [],
      totalSize: 0,
      Diagnosis:'',
      ChiefComplaint:'',
      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading: false,
      link: '#',
      message:'',
      error:true,
      loading: false,
      ProviderCode : '',
      ProviderName : '',
      errorMessage: '',
      modalVisible: false,
      vueTel: {
        phone: "",
        props: {
          preferredCountries: ["PH"],
          placeholder: "Enter your phone",
          mode: "international",
          inputOptions: {
            showDialCode: true
          },
          disabledFormatting: false,
          wrapperClasses: "country-phone-input"
        }
      },
      vuePhone: {
        phone: "",
        verify: "",
        props: {
          clearable: true,
          fetchCountry: true,
          preferredCountries: ["PH"],
          noExample: false,
          translations: {
            countrySelectorLabel: "Country code",
            countrySelectorError: "Error",
            phoneNumberLabel: "Enter your phone",
            example: "Example:"
          }
        }
      },
      visible: false,
        layout: "normal",
        input: null,
        options: {
        useKbEvents: false,
        preventClickEvent: false,
        
    },
      /* Non Affiliated 08/27/2025 */
      isNonAffiliated: false,        
      nonAffiliatedDoctorName: '',   
      nonAffiliatedSpecialization: '', 
      doctorType: 'company',
      proceed: true,
      agmtNo: '',
      isMayaAccount: 'N'
    }
  },
  watch() {
    console.log(document.activeElement);
  },
  created() {
      //localStorage.removeItem('CertNo');
      if (localStorage.getItem('CertNo') === null) {
          this.$router.push('/login');
      }
      
  },
  methods: {
    async handleSearch() {
      this.TokenID = localStorage.getItem('TokenID')
       this.certNo = localStorage.getItem('CertNo')
        const response = await axios.post('/api/?action=member-doctor-name', {
           FirstName: this.FirstName,
           TokenID: this.TokenID,
           LastName: this.LastName,
           ServiceType: 'LABORATORY',
           ProviderCode: this.ProviderCode,
           ProviderName: this.ProviderName,
           CertNo: this.certNo
        }, 
        );

        console.log(response);
        this.Doctors=response.data

        
        
    },
    showError(message) {
        this.errorMessage = message;
        this.$refs['error-modal'].show()
        
        document.getElementById('upload-modal').style.display = 'none';
        //this.modalVisible = false;
      },
      clearErrorMessage() {
        this.errorMessage = '';
        document.getElementById('upload-modal').style.display = 'block';
      },
      
    logOut() {
        localStorage.removeItem('CertNo');
        localStorage.removeItem('allowLOAConsult');
        localStorage.removeItem('allowLOALab');
        this.$router.push('/login');

    },
    previousStep(){
      this.step = this.step-1
       if (this.step == 0) {
        this.isNonAffiliated = false;
      }
    },
    nextStep(){
      this.step = this.step+1
      //console.log(this.step, this.loginType);
      //if (this.loginType=="firstCons" && this.step == 3){
       // this.handleSubmit()
      //}
      
    },
    nextSteps(){
      this.steps = this.steps+1
    },
    showModal() {
            this.$refs['my-modal'].show()
          },
    previousSteps(){
      this.steps = this.steps-1
      
      if(!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 50;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }
      this.isPhotoTaken = !this.isPhotoTaken;

      const context = this.$refs.canvas.getContext('2d');
      context.drawImage(this.$refs.camera, 0, 0, 450, 337.5);
    },
    closeModal() {
      this.steps = this.steps-1
      this.hideModal2();
    },
    closeModalError() {
      this.$refs['my-modal'].hide();
    },
    async handleSubmit() {
      console.log('step', this.step);
      if(this.step==5){
          this.TokenID = localStorage.getItem('TokenID')
          this.certNo = localStorage.getItem('CertNo')
          var pnumberOnly = this.vuePhone.phone.replace(/[^\d]/g, '');
            if (pnumberOnly.length < 11) {
              this.message="Invalid Mobile Number. Please try again."
              this.showModal()
              this.error = true

            } else if (this.vuePhone.phone != this.vuePhone.verify){
              this.message="Mobile Number did not match. Please try again."
              this.showModal()
              this.error = true
            } else  {
            

           
      /*  if (this.isNonAffiliated) {
      try {
        const result = await this.$bvModal.msgBoxConfirm(
          "The doctor is not accredited/non-affiliated. Do you want to proceed?",
          {
            title: "Non-Affiliated Doctor",
            okTitle: "Yes",
            cancelTitle: "No",
            centered: true,
            size: "sm",
            modalClass: "non-affiliated-confirm",
            headerClass: "non-affiliated-header",
            footerClass: "non-affiliated-footer",
          }
        );

        this.proceed = result; // true if Yes, false if No
      } catch (err) {
        this.proceed = false;
      }
    } */

    //  console.log('PROCEED', this.proceed);

    if (!this.proceed) {
      return;
    }
          this.loading = true
          this.message = "We are processing your request now. Please wait..."
          this.error = false
          this.showModal()

          const payload = {
                CertNo: this.certNo,
                Diagnosis: this.Diagnosis,
                ChiefComplaint: this.ChiefComplaint,
                Attachement: this.Attachement,
                vuePhone: this.vuePhone.phone,
                ProviderCode: this.ProviderCode,
                ProviderName: this.ProviderName
          };

          if (this.isNonAffiliated) {
            // mark as non-affiliated
            payload.DoctorCode = 0;
            payload.DoctorName = this.nonAffiliatedDoctorName;
            payload.Specialization = this.nonAffiliatedSpecialization;
            payload.DoctorType = this.doctorType;
          } else {
            payload.Specialization = '';
            payload.DoctorCode = this.DoctorCode;
            payload.DoctorName = this.DoctorName;
          }

          console.log('ChiefComplaint', this.ChiefComplaint);


        try {
              const response = await axios.post('/api/?action=member-loa-laboratory', payload);
              this.Doctors=response.data
              if (response.data.SuccessFlag == "True"){
                this.loading = false
                this.message="We have received your request. Our Customer Experience Advocate will reach out to you shortly. You may leave this Smart LOA and wait for our call. Thank you and have a nice day."
                this.error = false
              } else {
                this.message=response.data.errorMessage
                this.error = false
              }
                    //localStorage.setItem('TokenID', response.data.TokenID)
                    
                  this.showModal()
              
            }
         catch (error) {
            this.loading = false
            console.log(error.message);
            this.message=error.message;
            this.showModal()
        }

        
            
      }
      }
      if (this.step < 5) {
         this.nextStep()
         }
    },
    async searchDoctor() {
      //this.agmtNo = localStorage.getItem('AgmtNo')
      this.certNo = localStorage.getItem('CertNo')
      this.isMayaAccount = localStorage.getItem('isMayaAccount')
      this.TokenID = localStorage.getItem('TokenID')
        const response = await axios.post('/api/?action=member-doctor-name', {
           FirstName: this.FirstName,
           LastName: this.LastName,
           ServiceType: 'LABORATORY',
           ProviderCode: this.ProviderCode,
           CertNo: this.certNo
        }, 
        );

        console.log('isMayaAccount', this.isMayaAccount);
        this.Doctors=response.data

         /* Non Affiliated 08/27/2025 */
        if (this.Doctors.length === 0 && this.isMayaAccount == 'Y') {
        // No doctor found, trigger modal confirmation
        this.$bvModal.msgBoxConfirm('Doctor not accredited/affiliated. Proceed?', {
          title: 'Non-Affiliated Doctor',
          okTitle: 'Yes',
          cancelTitle: 'No',
          centered: true,
          size: 'sm',
          modalClass: 'non-affiliated-confirm',  // custom modal class
          headerClass: 'non-affiliated-header', // optional header style
          footerClass: 'non-affiliated-footer'  // optional footer style
        }).then(value => {
          if (value) {
            this.isNonAffiliated = true;
            this.$refs['search-modal'].hide(),
            this.$refs['name-modal'].hide()
          } else {
             this.$refs['search-modal'].hide(),
            this.isNonAffiliated = false;
          }

          console.log('isNonAffiliated value:', this.isNonAffiliated)
        });
      }

    },
    handleSelectItem(item){
      console.log(item);
      this.DoctorName = item.DoctorName
      this.DoctorCode = item.DoctorCode
      this.hideModal()
    },
    hideModal() {
      this.$refs['search-modal'].hide();
      this.$refs['name-modal'].hide();
    },
    hideModal2(){
      this.$refs['scan-modal'].hide();
    },
    onModalClose() {
        this.Attachement = [];
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.stopCameraStream();
    }, 

    onModalCloseUpload() {
         this.Attachement = [];
         this.uploadedImages.splice(0); 
    },

    toggleFileUpload() {
      this.$refs['upload-modal'].show();
    },

    toggleCamera() {
      console.log('HERE');
      if(this.isCameraOpen) {
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.stopCameraStream();
      } else {
        this.isCameraOpen = true;
        this.createCameraElement();
      }
    },
    
    createCameraElement() {
      this.isLoading = true;
      
      const constraints = (window.constraints = {
        audio: false,
        video: true
      });


      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(stream => {
          this.isLoading = false;
          this.$refs.camera.srcObject = stream;
        })
        
    },
    
    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks();

      tracks.forEach(track => {
        track.stop();
      });
    },
    
    takePhoto() {
      
      if(!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 50;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }
      
      this.isPhotoTaken = !this.isPhotoTaken;
      
      const context = this.$refs.canvas.getContext('2d');
      context.drawImage(this.$refs.camera, 0, 0, 450, 337.5);
      const canvas = document.getElementById("photoTaken").toDataURL()
      this.Attachement.push(canvas);
      this.nextSteps()
      console.log(this.Attachement);
    },
    
    downloadImage() {
      const download = document.getElementById();
      const canvas = document.getElementById("photoTaken").toDataURL()
      download.setAttribute(canvas);
    },
    
    accept() {
          this.hide();
        },
 
        show(e) {
          this.input = e.target;
          this.layout = e.target.dataset.layout;
 
          if (!this.visible)
            this.visible = true
          
        },
 
        hide() {
          this.visible = false;
          console.log(document.querySelector(":focus"));
        },
        
        updateParentProvider(value_from_child) {
          if (value_from_child != 0) {
              this.step = 1
              this.ProviderCode = value_from_child
          }
        },

        updateParentProviderName(value_from_child) {
          if (value_from_child != 0) {
              this.ProviderName = value_from_child
          }
        },
       handleFileUpload(inputIndex, event) {
          const input = event.target;
         // const file = input.files[0];



          // Check file size
          /*if (file.size > 1024 * 1024) {
            alert("File size exceeds 1MB limit.");
            input.value = ''; 
            return;
          } */

         const file = event.target.files[0];
      if (!file) {
        this.$set(this.uploadedImages, inputIndex - 1, null);
        return;
      } 

      if (this.files[inputIndex - 1]) {
        this.totalSize -= this.files[inputIndex - 1].size;
      }
     

      if (this.totalSize + file.size > 10 * 1024 * 1024) {
        
          this.showError("Total file size exceeds the requirement. Please resize or compress to a total of less than 10 MB. Thank you");
          input.value = ''; // Clear the input field
          return;
      }
      
      this.$set(this.files, inputIndex - 1, file);
      this.totalSize += file.size;

          // Reset uploadedImages array
         // this.Attachement = [];
          
          // Display selected image for preview
      const reader = new FileReader();
        reader.onload = () => {
        this.$set(this.uploadedImages, inputIndex - 1, { url: reader.result, file: file });
      };
      reader.readAsDataURL(file);

     // this.totalSize += file.size;
          
         
    },
    
    UploadImages() {
      this.uploadedImages.forEach(image => {
        if (image && image.url) {
          this.Attachement.push(image.url);
        }
      });

      this.uploadedImages = [];

      this.nextStep()
    },
    focusFirstInput() {
      this.$refs.firstInput.focus();
  },   
  },
  components: {
    FindAProvider
  }
    
    
    
  }


</script>

<style scoped>
button.close {
    display: none !important;
}

/*.login-form p {
    font-size: 28px !important;
} */

.modal-dialog-centered {
    max-width: 69% !important;
}
</style>


<!-- Add "scoped" attribute to limit CSS to this component only -->
